import { render, staticRenderFns } from "./extraTab.vue?vue&type=template&id=4527f724&scoped=true&"
import script from "./extraTab.vue?vue&type=script&lang=js&"
export * from "./extraTab.vue?vue&type=script&lang=js&"
import style0 from "./extraTab.vue?vue&type=style&index=0&id=4527f724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4527f724",
  null
  
)

export default component.exports